<template>
  <div>
    <portal to="top-bar-right">
      <div class="flex justify-right">
        <YButton
          class="btn btn-blue "
          @click="openCreateNewRtbModal"
          :is-loading="isCreating"
        >
          New RTB
        </YButton>
      </div>
    </portal>

    <div v-if="campaignRtbs">
      <RTBTable :data="campaignRtbs.data || []" />
    </div>
  </div>
</template>

<script>
import RTBTable from '@/views/Admin/Campaign/RTBTable.vue'
import RTBUpsertModal from '@/views/Admin/Campaign/RTBUpsertModal.vue'
import CAMPAIGN_RTBS_QUERY from '@/graphql/Campaign/CampaignsRtbsQuery.gql'
export default {
  components: {
    RTBTable
  },
  data() {
    return {
      isCreating: false,
      campaignRtbsList: []
    }
  },
  apollo: {
    campaignRtbs: {
      query: CAMPAIGN_RTBS_QUERY,
      variables() {
        return {
          first: 999,
          page: 1
        }
      },
      result() {}
    }
  },
  methods: {
    openCreateNewRtbModal() {
      this.$modal.show(
        RTBUpsertModal,
        {},
        {
          height: 'auto',
          width: '80%',
          maxWidth: 600,
          adaptive: true,
          scrollable: true
        }
      )
    }
  },
  mounted() {
    this.$events.listen('refetchCampaignRtbs', () => {
      this.$apollo.queries.campaignRtbs.refetch()
    })
  },
  beforeDestroy() {
    this.$events.remove('refetchCampaignRtbs')
  }
}
</script>
